var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "line", class: "property_" + _vm.property.propertyId },
    [
      _c("span", { staticClass: "label" }, [
        _vm._v(
          "\n        " + _vm._s(_vm.property.property.names.name) + " \n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "span",
        { staticClass: "text" },
        [
          _vm.surcharge > 0
            ? [
                _vm.isAdditionalCost || _vm.isTaxless
                  ? [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$translate("Ceres::Template.basketPlusAbbr")
                          ) +
                          " " +
                          _vm._s(_vm._f("currency")(_vm.surcharge)) +
                          "\n            "
                      )
                    ]
                  : [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$translate("Ceres::Template.basketIncludeAbbr")
                          ) +
                          " " +
                          _vm._s(_vm._f("currency")(_vm.surcharge)) +
                          "\n            "
                      )
                    ]
              ]
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }